module.exports = __webpack_public_path__ + "img/Folded_Paper_icon_product_design.25ca1f1e.svg";